"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_ROLE_LABELS = void 0;
exports.isRoleLabel = isRoleLabel;
exports.resolveRoleLabels = resolveRoleLabels;
exports.roleLabel = roleLabel;
exports.DEFAULT_ROLE_LABELS = {
    THERAPIST: { singular: "Therapeut:in", plural: "Therapeut:innen" },
    LEARNER: { singular: "Lernende:r", plural: "Lernende" },
};
function isRoleLabel(value) {
    return typeof value === "string" && value.trim().length >= 2 && value.trim().length <= 80
        && !/[\u0000-\u001f\u007f\u0085\u2028\u2029]/u.test(value);
}
function resolveRoleLabels(settings) {
    const saved = settings && typeof settings === "object" && !Array.isArray(settings)
        ? settings : {};
    const therapist = isRoleLabel(saved.therapistLabel) ? saved.therapistLabel.trim() : exports.DEFAULT_ROLE_LABELS.THERAPIST.singular;
    const learner = isRoleLabel(saved.learnerLabel) ? saved.learnerLabel.trim() : exports.DEFAULT_ROLE_LABELS.LEARNER.singular;
    return {
        THERAPIST: {
            singular: therapist,
            plural: isRoleLabel(saved.therapistLabelPlural) ? saved.therapistLabelPlural.trim()
                : therapist === exports.DEFAULT_ROLE_LABELS.THERAPIST.singular ? exports.DEFAULT_ROLE_LABELS.THERAPIST.plural : therapist,
        },
        LEARNER: {
            singular: learner,
            plural: isRoleLabel(saved.learnerLabelPlural) ? saved.learnerLabelPlural.trim()
                : learner === exports.DEFAULT_ROLE_LABELS.LEARNER.singular ? exports.DEFAULT_ROLE_LABELS.LEARNER.plural : learner,
        },
    };
}
function roleLabel(labels, role, form = "singular", showStandard = false) {
    if (role === "ADMIN")
        return "Globaler Admin";
    if (role === "ORGANIZATION")
        return "Einrichtung";
    const standard = exports.DEFAULT_ROLE_LABELS[role][form];
    const label = labels?.[role]?.[form];
    const text = isRoleLabel(label) ? label.trim() : standard;
    return showStandard && text !== standard ? `${text} (${standard})` : text;
}
//# sourceMappingURL=role-labels.js.map